import React from "react";
import "./style.css";
import Card from "./card";
import Spinner from "../../../../components/spinner";
import { Row, Col } from "antd";

export default class CoursesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedIndex: null };
  }

  render() {
    const { courses, user, firstCourseID } = this.props;
    // console.log(user);
    return (
      <div>
        {courses.length === 0 ? (
          <div className="tc">
            <Spinner />
          </div>
        ) : (
          <div className="centralDivCourse">
            <Row gutter={[24, 24]}>
              {courses.map((item, index) => {
                return (
                  <Col
                    span={6}
                    onClick={() => {
                      this.setState({ selectedIndex: index });
                    }}
                  >
                    <Card
                      onPageChange={this.props.onPageChange}
                      course={item}
                      user={user}
                      firstCourseID={firstCourseID}
                      courseIndex={index}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </div>
    );
  }
}
